import apiClient from './authService';

const contactGroupService = {
  // Get all contact groups
  async getContactGroups() {
    const response = await apiClient.get('/contacts/groups');
    return response.data;
  },

  // Get a specific contact group by ID
  async getContactGroupById(groupId) {
    const response = await apiClient.get(`/contacts/groups/${groupId}`);
    return response.data;
  },

  // Create a new contact group
  async createContactGroup(groupData) {
    const response = await apiClient.post('/contacts/groups', groupData);
    return response.data;
  },

  // Update a contact group
  async updateContactGroup(groupId, groupData) {
    const response = await apiClient.put(`/contacts/groups/${groupId}`, groupData);
    return response.data;
  },

  // Delete a contact group
  async deleteContactGroup(groupId) {
    const response = await apiClient.delete(`/contacts/groups/${groupId}`);
    return response.data;
  },

  // Add contacts to a group
  async addContactsToGroup(groupId, contactIds) {
    const response = await apiClient.post(`/contacts/groups/${groupId}/contacts`, {
      contactIds: contactIds
    });
    return response.data;
  },

  // Remove contacts from a group
  async removeContactsFromGroup(groupId, contactIds) {
    const response = await apiClient.delete(`/contacts/groups/${groupId}/contacts`, {
      data: { contactIds: contactIds }
    });
    return response.data;
  }
};

export { contactGroupService };
